/** This is a placeholder, not real render in dom */
var OptGroup = function OptGroup() {
  return null;
};

OptGroup.isSelectOptGroup = true;
export default OptGroup;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-select@10.2.1@rc-select/es/OptGroup.js
// module id = 248
// module chunks = 0